import { Conta, ContasSearchBox, error99, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const ContaService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Conta/Attributes', 'get', { id })
        const attributes: Conta = {
            id: 0,
            descricao: '',
            description: '',
            id_user_insert: 0,
            id_user_last_update: 0,
            id_user_exclusao: 0,
            motivo_exclusao: '',
            dt_cadastro: '',
            dt_last_update: '',
            dh_exclusao: '',
            name_user_insert: '',
            name_user_last_update: '',
            name_user_delete: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.conta) {

                    attributes.id = resp.data.conta.id
                    attributes.descricao = resp.data.conta.descricao
                    attributes.description = resp.data.conta.descricao
                    attributes.id_user_insert = resp.data.conta.id_user_insert
                    attributes.id_user_last_update = resp.data.conta.id_user_last_update
                    attributes.id_user_exclusao = resp.data.conta.id_user_exclusao
                    attributes.motivo_exclusao = resp.data.conta.motivo_exclusao
                    attributes.dt_cadastro = resp.data.conta.dt_cadastro
                    attributes.dt_last_update = resp.data.conta.dt_last_update
                    attributes.dh_exclusao = resp.data.conta.dh_exclusao
                    attributes.name_user_insert = resp.data.conta.name_user_insert
                    attributes.name_user_last_update = resp.data.conta.name_user_last_update
                    attributes.name_user_delete = resp.data.conta.name_user_delete

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (conta: Conta): Promise<RetAPI> => {

        let id = ''

        if (conta.id) {
            id = conta.id.toString()
        }

        const resp = await Api('Conta/Save', 'post', { descricao: conta.descricao, id })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados da conta gravados com sucesso',
                id: resp.data.conta.id,
                data: resp.data,
                dt_cadastro: resp.data.conta.dt_cadastro,
                dt_last_update: resp.data.conta.dt_last_update,
                name_user_insert: resp.data.conta.name_user_insert,
                name_user_last_update: resp.data.conta.name_user_last_update
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Conta/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Conta/Filter', 'get', { field, filter_type, filter, id })
        const contas: Conta[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: contas
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.contas.map((item: any) => {
                    return contas.push({

                        id: item.id,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        descricao: item.descricao,
                        description: item.descricao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete

                    })
                })

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contas
            }
        }

        return {
            error: false,
            data: contas
        }

    },

    FilterExcluidas: async (relatorio: any): Promise<RetAPI> => {

        const resp = await Api('Conta/Filter/Excluidas', 'get', {
            datai: relatorio.datai,
            dataf: relatorio.dataf,
            descricao: relatorio.descricao
        })
        const conta: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: conta
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.contas.map((item: any) => {
                    return conta.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        descricao: item.descricao,
                        name_user_delete: item.name_user_delete,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: conta
            }
        }

        return {
            error: false,
            data: conta,
        }

    },

    GetListConta: async (): Promise<RetAPI> => {

        const resp = await Api('Conta/List', 'get')
        const contas: ContasSearchBox[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: contas
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.contas.map((item: any) => {
                    return contas.push({

                        id: item.id,
                        description: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contas
            }
        }

        return {
            error: false,
            data: contas
        }
    },
}
